type DevToolsElement = [string, Record<string, string>, ...(string | DevToolsElement)[]];

interface DevToolsFormatter {
    header(obj: unknown): DevToolsElement | null;
    hasBody(obj: unknown): boolean;
    body(obj: unknown): DevToolsElement | null;
}

declare global {
    interface Window {
        devtoolsFormatters?: DevToolsFormatter[];
    }
}

/**
 * Registers custom formatters for Luminary assets in browser dev tools
 */
export function registerDevtoolsFormatters(): void {
    if (typeof window === 'undefined') {
        return;
    }

    const assetFormatter: DevToolsFormatter = {
        header(obj: unknown): DevToolsElement | null {
            if (!obj || typeof obj !== 'object') return null;
            const asset = obj as Record<string, unknown>;
            if (!asset.classType || typeof asset.classType !== 'string') return null;

            const displayText = asset.name
                ? `${asset.classType} (${String(asset.name)})`
                : asset.classType;

            return ['span', {}, displayText];
        },

        hasBody(): boolean {
            return true;
        },

        body(): null {
            return null;
        },
    };

    window.devtoolsFormatters = window.devtoolsFormatters || [];
    window.devtoolsFormatters.push(assetFormatter);
}
